
(function($) {
    $(document).ready(function () {
        restaurantMenus();
    });

    function restaurantMenus() {
        var wrap = $('.section.menus_carousel .slider');
        if (wrap.length > 0 && wrap.find('.item_wrap').length > 1) {
            wrap.each(function () {
                var single_wrap = $(this);
                single_wrap.on("init", function () {
                    lazyLoadInstance.update();
                });

                single_wrap.slick({
                    autoplay: false,
                    arrows: true,
                    prevArrow: accor_arrow_prev,
                    nextArrow: accor_arrow_next,
                    dots: true,
                    infinite: true,
                    appendDots: single_wrap.closest('.section').find('.pager_mobile'),
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    variableWidth: false,
                    centerMode: false,
                    rtl: $('html').attr('dir') == 'rtl',
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                            }
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                appendDots: single_wrap.closest('.section').find('.pager_mobile'),
                            }
                        },
                    ]
                });
            });
        }
    }
})(jQuery);